import Header from './Header';
import MainArea from './MainArea';
export default function AppLayout({children, className}) {
	return (
		<div className={className}>
		<Header /> 
		<MainArea />
		</div>
	)
}